module.exports = __webpack_public_path__ + "h5/img/rijin.543ec04e.png";